/** Copyright (c) 2019 T. Rowe Price. All rights reserved. */

import './MailingAddress.scss';

import { func, string, number } from 'prop-types';

import React from 'react';

const ZipCode = ({ maxLength, onBlur, onChange, value, dataTestId }) => {
  return (
    <input
      className="address-input address-input-zip"
      maxLength={maxLength}
      onBlur={onBlur}
      onChange={onChange}
      value={value}
      data-testid={dataTestId}
    />
  );
};

ZipCode.propTypes = {
  onBlur: func.isRequired,
  onChange: func.isRequired,
  value: string.isRequired,
  maxLength: number.isRequired
};

export default ZipCode;
